(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    for (const button of document.querySelectorAll('[data-copy-link]')) {
      const status = button.parentElement.querySelector('[data-copy-status]');

      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.copyLink);
          status.textContent = button.closest('.article').dataset.copiedLabel;
        } catch {
          window.prompt('', button.dataset.copyLink);
          return;
        }

        window.setTimeout(() => {
          status.textContent = '';
        }, 2000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (() => {
    for (const section of document.querySelectorAll('.journal')) {
      const grid = section.querySelector('[data-journal-grid]');
      const more = section.querySelector('[data-journal-more]');
      const form = section.querySelector('[data-journal-search]');
      if (!grid) continue;

      let loading = null;

      // Fetches the page the "Load more" link points at and appends its cards.
      // The link then points at the page after, or goes away on the last one.
      const loadNext = () => {
        const link = more?.querySelector('a');
        if (!link || !section.contains(more)) return Promise.resolve(false);
        if (loading) return loading;

        grid.setAttribute('aria-busy', 'true');

        loading = fetch(link.href)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((html) => {
            const page = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = page.getElementById(grid.id);
            if (!nextGrid) return false;

            const cards = nextGrid.querySelectorAll('[data-article-card]');
            grid.append(...[...cards].map((card) => document.importNode(card, true)));

            const next = nextGrid.parentElement.querySelector('[data-journal-more] a');
            if (next) {
              link.href = next.href;
            } else {
              more.remove();
            }
            return true;
          })
          // On failure the link stays as a plain link to the next page.
          .catch(() => false)
          .finally(() => {
            grid.removeAttribute('aria-busy');
            loading = null;
          });

        return loading;
      };

      const loadAll = async () => {
        while (await loadNext()) {}
      };

      // Infinite scroll: start loading a little before the end comes into view.
      if (more && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          async (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            const loaded = await loadNext();

            if (!section.contains(more)) {
              observer.disconnect();
            } else if (loaded) {
              // The observer only reports changes, so a link still in range
              // after the new cards land would never fire again. Observing it
              // afresh delivers its current state and loads the next page too.
              observer.unobserve(more);
              observer.observe(more);
            }
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        observer.observe(more);
      }

      if (!form) continue;

      const input = form.querySelector('input[type="search"]');
      const empty = section.querySelector('[data-journal-empty]');

      // Nothing to filter on an empty journal: let the form reach search.
      if (!grid.querySelector('[data-article-card]')) continue;

      const filter = async () => {
        const terms = input.value.toLowerCase().trim().split(/\s+/).filter(Boolean);

        // Matches can sit on pages not loaded yet.
        if (terms.length) await loadAll();

        let shown = 0;
        for (const card of grid.querySelectorAll('[data-article-card]')) {
          const match = terms.every((term) => card.dataset.search.includes(term));
          card.hidden = !match;
          if (match) shown += 1;
        }

        empty.hidden = shown > 0;
      };

      input.addEventListener('input', filter);

      // The cards already filter as the visitor types, so Enter stays here
      // instead of leaving for the search page.
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filter();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // The cart works with no JavaScript at all: quantities and removal are a
  // plain form POST. This upgrades that in two ways, and both have to go
  // through /cart/change.js because POST /cart only understands updates[]:
  //
  //   * the gift notes, which are line item properties and cannot ride the POST;
  //   * the quantity buttons, which apply immediately instead of waiting for
  //     Update.
  //
  // The two are really one feature. A card goes in every box, so a line of N
  // boxes carries N notes, and moving the quantity adds an empty field or drops
  // the last one.
  (function () {
    // Long enough not to fire mid-word, short enough to land before Checkout.
    const SAVE_DELAY = 600;

    // Must match `gift_property` in the Liquid above, which reads them back.
    // Properties are numbered from one: "Gift message 1", "Gift message 2"...
    const PROPERTY_PREFIX = 'Gift message';

    // Save state per field, keyed by the textarea. The fields are replaced
    // wholesale whenever the quantity moves, so nothing is bookkept across
    // that: a fresh field starts from what the server rendered into it.
    const lastSaved = new WeakMap();
    const timers = new WeakMap();

    function saved(input) {
      if (!lastSaved.has(input)) lastSaved.set(input, input.defaultValue.trim());
      return lastSaved.get(input);
    }

    function init() {
      const form = document.querySelector('.cart-page__form');
      if (!form) return;

      const sectionId = form.dataset.sectionId;
      const changeUrl = form.dataset.cartChangeUrl + '.js';
      const maxBoxes = Number(form.dataset.giftMaxBoxes);

      // change.js is not safe to call in parallel: two in flight can undo each
      // other. Everything is chained onto this one promise instead of racing.
      let queue = Promise.resolve();
      let pending = 0;

      // change.js overwrites the whole properties object, so every write has to
      // carry the complete set. `limit` is what trims the tail when the
      // quantity drops: fields past the new count are simply not collected.
      function collect(wrapper, limit) {
        const properties = {};

        wrapper.querySelectorAll('[data-gift-input]').forEach((input, index) => {
          if (index >= limit) return;

          const value = input.value.trim();
          // A blank box sends no property at all, so it comes through clean
          // and gets the house note.
          if (value) properties[PROPERTY_PREFIX + ' ' + (index + 1)] = value;
        });

        return properties;
      }

      // Prices are read back out of a freshly rendered copy of this very
      // section rather than formatted in JavaScript, so `money` stays the one
      // place currency is spelled out.
      function repaint(html, relist) {
        const next = new DOMParser().parseFromString(html, 'text/html');

        const copy = (selector, apply) => {
          const fresh = next.querySelectorAll(selector);
          form.querySelectorAll(selector).forEach((node, i) => {
            if (fresh[i]) apply(node, fresh[i]);
          });
        };

        copy('[data-line-total]', (node, fresh) => {
          node.textContent = fresh.textContent;
        });
        copy('[data-cart-subtotal]', (node, fresh) => {
          node.textContent = fresh.textContent;
        });

        // Keep the quantity a note save reports in step with the cart, or the
        // next note would roll the quantity back.
        copy('[data-gift-line]', (node, fresh) => {
          node.dataset.giftQuantity = fresh.dataset.giftQuantity;
        });

        // Only once the quantity has moved. Liquid has just rendered the right
        // number of fields, with the right labels and the saved values, which
        // beats assembling them here. It is skipped on a plain note save, or it
        // would take the caret from whoever is typing.
        if (!relist) return;

        copy('[data-gift-list]', (node, fresh) => {
          node.innerHTML = fresh.innerHTML;
          paintCounters(node);
        });
      }

      function change(body, relist) {
        pending += 1;

        const run = queue.then(async () => {
          const response = await fetch(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            // `line` rather than `id`, because writing properties changes the
            // line's key and any key held in the DOM goes stale.
            body: JSON.stringify(Object.assign({ sections: sectionId }, body)),
          });
          if (!response.ok) throw new Error('Cart change failed');

          const data = await response.json();
          if (data.sections && data.sections[sectionId]) repaint(data.sections[sectionId], relist);

          // The header owns its badge; this only tells it the new count.
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: data.item_count } }));

          return data;
        });

        // The chain itself must never reject, or every later write is skipped.
        queue = run.then(
          () => {},
          () => {}
        );
        run
          .catch(() => {})
          .then(() => {
            pending -= 1;
          });

        return run;
      }

      // Shopify hands line item properties back HTML-escaped, and its `escape`
      // filter leaves existing entities alone, so the value round-trips
      // correctly but Liquid's `size` counts the escaped form: a single
      // apostrophe reads as four characters. The counters are therefore
      // repainted from the decoded value in the field, which is what the
      // shopper actually typed. Liquid still renders them for the no-JS case.
      function paintCounters(scope) {
        scope.querySelectorAll('[data-gift-input]').forEach((input) => {
          const box = input.closest('[data-gift-box]');
          const counter = box && box.querySelector('[data-gift-count]');
          if (counter) counter.textContent = input.value.length + '/' + input.maxLength;
        });
      }

      function announce(wrapper, key) {
        const node = wrapper.querySelector('[data-gift-status]');
        if (node) node.textContent = key ? node.dataset[key] : '';
      }

      // --- notes ------------------------------------------------------------
      function saveNotes(wrapper) {
        const inputs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-gift-input]'));
        const values = inputs.map((input) => input.value.trim());

        // Nothing to do while every box still holds what the server has.
        if (inputs.every((input, i) => values[i] === saved(input))) return;
        inputs.forEach((input, i) => lastSaved.set(input, values[i]));

        const quantity = Number(wrapper.dataset.giftQuantity);

        change(
          {
            line: Number(wrapper.dataset.giftLine),
            // The quantity has to be repeated: change.js assumes 1 when it is
            // left out, which would shrink a line of three boxes to one.
            quantity: quantity,
            properties: collect(wrapper, quantity),
          },
          false
        )
          .then(() => announce(wrapper, 'saved'))
          .catch(() => {
            // Keep what was written and let the next edit try again.
            inputs.forEach((input) => lastSaved.delete(input));
            announce(wrapper, 'error');
          });
      }

      // Delegated, because the fields are replaced wholesale every time the
      // quantity moves and binding each one would need rewiring every time.
      form.addEventListener('keydown', (event) => {
        if (!event.target.closest('[data-gift-input]')) return;
        // A card is printed on one line, so Enter has nothing to do here.
        if (event.key === 'Enter') event.preventDefault();
      });

      form.addEventListener('input', (event) => {
        const input = event.target.closest('[data-gift-input]');
        if (!input) return;

        // maxlength already covers typing; this is for a pasted paragraph.
        const cleaned = input.value.replace(/[\r\n\t]+/g, ' ').slice(0, input.maxLength);
        if (cleaned !== input.value) input.value = cleaned;

        const box = input.closest('[data-gift-box]');
        if (box) paintCounters(box);

        const wrapper = input.closest('[data-gift-line]');
        announce(wrapper, null);

        clearTimeout(timers.get(input));
        timers.set(
          input,
          setTimeout(() => saveNotes(wrapper), SAVE_DELAY)
        );
      });

      form.addEventListener('change', (event) => {
        const input = event.target.closest('[data-gift-input]');
        if (!input) return;

        clearTimeout(timers.get(input));
        saveNotes(input.closest('[data-gift-line]'));
      });

      // --- quantity ---------------------------------------------------------
      function syncSteps(group) {
        const value = Number(group.querySelector('[data-quantity-input]').value);

        group.querySelectorAll('[data-quantity-step]').forEach((button) => {
          // One box is the floor, and Remove is how a line leaves the cart.
          // The ceiling is what Liquid can render without dropping notes.
          const down = Number(button.dataset.quantityStep) < 0;
          button.disabled = down ? value <= 1 : value >= maxBoxes;
        });
      }

      function step(group, delta) {
        const input = group.querySelector('[data-quantity-input]');
        const previous = Number(input.value);
        const value = previous + delta;
        if (value < 1 || value > maxBoxes) return;

        const wrapper = group.closest('.cart-item').querySelector('[data-gift-line]');

        input.value = value;
        syncSteps(group);

        // One write does both. Collecting with the new count as the limit is
        // what drops the last box's note when the quantity goes down, and
        // reading the live fields means text typed but not yet saved rides
        // along rather than being lost.
        const properties = collect(wrapper, value);
        wrapper.dataset.giftQuantity = value;

        change({ line: Number(group.dataset.quantityLine), quantity: value, properties: properties }, true).catch(
          () => {
            // Put the number back rather than leave a total that never was.
            input.value = previous;
            wrapper.dataset.giftQuantity = previous;
            syncSteps(group);
          }
        );
      }

      form.querySelectorAll('[data-quantity]').forEach((group) => {
        // Typing is out now that the buttons own the value, but the field is
        // read-only rather than disabled so it still carries updates[].
        group.querySelector('[data-quantity-input]').readOnly = true;

        group.querySelectorAll('[data-quantity-step]').forEach((button) => {
          button.hidden = false;
          button.addEventListener('click', () => step(group, Number(button.dataset.quantityStep)));
        });

        syncSteps(group);
      });

      paintCounters(form);

      // Nothing left for Update to apply once the buttons are live.
      const actions = form.querySelector('[data-cart-actions]');
      if (actions) actions.classList.add('cart-page__actions--instant');

      // Without this, typing a note and going straight to Checkout navigates
      // away before the save lands and the note is lost.
      form.addEventListener('submit', (event) => {
        form.querySelectorAll('[data-gift-input]').forEach((input) => clearTimeout(timers.get(input)));
        form.querySelectorAll('[data-gift-line]').forEach((wrapper) => saveNotes(wrapper));

        if (pending === 0) return;

        event.preventDefault();
        const submitter = event.submitter;

        queue.then(() => {
          // requestSubmit re-runs this handler, but by then nothing is pending
          // and it falls through to the real submit.
          if (form.requestSubmit) {
            form.requestSubmit(submitter);
            return;
          }

          // Older browsers: form.submit() drops the pressed button's name, and
          // the cart needs it to tell Checkout from Update.
          if (submitter && submitter.name) {
            const carried = document.createElement('input');
            carried.type = 'hidden';
            carried.name = submitter.name;
            carried.value = submitter.value || '';
            form.appendChild(carried);
          }
          form.submit();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Adding to the cart is a plain form POST that works with no JavaScript at
  // all. This upgrades it so the shopper is never taken off the page they are
  // browsing: the item is added in the background and the header badge bumps.
  //
  // Lives in the header because the header renders on every page, so every
  // add-to-cart form on the storefront is covered by one listener.
  (function () {
    const badges = () => document.querySelectorAll('[data-cart-count]');

    function render(count) {
      badges().forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;

        if (count === 0) return;

        // Restart the animation even when the badge is bumped twice quickly.
        badge.classList.remove('header__badge--bumped');
        void badge.offsetWidth;
        badge.classList.add('header__badge--bumped');
      });
    }

    // The cart page changes quantities without a reload. It announces the new
    // count rather than reaching into the badge, so the bump stays defined here.
    document.addEventListener('cart:updated', (event) => {
      render(event.detail.count);
    });

    document.addEventListener('animationend', (event) => {
      if (event.target.matches('[data-cart-count]')) {
        event.target.classList.remove('header__badge--bumped');
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action$="/cart/add"]');
      if (!form) return;

      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      try {
        const added = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!added.ok) throw new Error('Add to cart failed');

        // /cart/add.js returns the line item, not the cart, so the count comes
        // from a second call rather than being counted in the DOM. The URL is
        // derived from the form's own action so it keeps any market or locale
        // prefix, which a hardcoded '/cart.js' would drop.
        const cartUrl = `${form.action.replace(/\/add$/, '')}.js`;
        const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
        if (!cart.ok) throw new Error('Cart fetch failed');

        render((await cart.json()).item_count);
      } catch (error) {
        // Fall back to the real form rather than swallow the shopper's intent.
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Reads "YYYY-MM-DD HH:MM" in the store's timezone, given as "+hhmm".
    const parseDate = (value, tz, seconds) => {
      if (!value) return null;
      const offset = /^[+-]\d{4}$/.test(tz) ? `${tz.slice(0, 3)}:${tz.slice(3)}` : 'Z';
      const date = new Date(`${value.replace(' ', 'T')}:${seconds}${offset}`);
      return Number.isNaN(date.getTime()) ? null : date;
    };

    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const track = root.querySelector('[data-hero-track]');
      const controls = root.querySelector('[data-hero-controls]');
      const dotsWrap = root.querySelector('[data-hero-dots]');
      const toggle = root.querySelector('[data-hero-toggle]');
      const designMode = Boolean(window.Shopify?.designMode);

      // The track's direct children are Shopify's block wrappers, and those are
      // what scroll, so every slide is handled through its wrapper.
      const items = () =>
        [...track.children].filter((item) => item.matches('[data-hero-slide]') || item.querySelector('[data-hero-slide]'));

      // Shopify can serve a cached page after a slide's window has closed, so
      // the dates are checked again here. The editor keeps every slide visible.
      if (!designMode) {
        const now = Date.now();
        for (const item of items()) {
          const slide = item.matches('[data-hero-slide]') ? item : item.querySelector('[data-hero-slide]');
          const start = parseDate(slide.dataset.start, root.dataset.tz, '00');
          const end = parseDate(slide.dataset.end, root.dataset.tz, '59');
          if ((start && now < start) || (end && now > end)) item.remove();
        }
      }

      const slides = items();
      if (slides.length < 2) return;

      const count = slides.length;
      let index = 0;

      const dots = slides.map((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-carousel__dot';
        dot.setAttribute(
          'aria-label',
          root.dataset.dotLabel.replace('[index]', i + 1).replace('[count]', count)
        );
        dot.addEventListener('click', () => {
          goTo(i);
          restart();
        });
        return dot;
      });
      dotsWrap.append(...dots);

      // Slides out of view are inert, so keyboard focus never lands on a
      // button the visitor cannot see.
      const render = () => {
        slides.forEach((slide, i) => {
          const current = i === index;
          slide.inert = !current;
          slide.setAttribute('aria-hidden', String(!current));
          dots[i].setAttribute('aria-current', String(current));
        });
      };

      const goTo = (i) => {
        const target = (i + count) % count;
        track.scrollTo({
          left: slides[target].offsetLeft - slides[0].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      };

      // The scroll position is the source of truth, so swipes, arrows, dots
      // and autoplay all end up in the same place.
      let frame = null;
      track.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = requestAnimationFrame(() => {
            frame = null;
            const next = Math.round(track.scrollLeft / track.clientWidth);
            if (next !== index && next >= 0 && next < count) {
              index = next;
              render();
            }
          });
        },
        { passive: true }
      );

      root.querySelector('[data-hero-prev]').addEventListener('click', () => {
        goTo(index - 1);
        restart();
      });
      root.querySelector('[data-hero-next]').addEventListener('click', () => {
        goTo(index + 1);
        restart();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goTo(index + (event.key === 'ArrowRight' ? 1 : -1));
        restart();
      });

      // Autoplay stops while the visitor is hovering, focused inside, or on
      // another tab, and for good once they press pause (WCAG 2.2.2).
      const autoplay = root.dataset.autoplay === 'true' && !designMode;
      const interval = Number(root.dataset.interval) || 6000;
      let timer = null;
      let hovered = false;
      let focused = false;
      let paused = reduceMotion.matches;
      let editing = false;

      const sync = () => {
        const run = autoplay && !paused && !hovered && !focused && !editing && !document.hidden;
        if (run && !timer) {
          timer = setInterval(() => goTo(index + 1), interval);
        } else if (!run && timer) {
          clearInterval(timer);
          timer = null;
        }
        track.setAttribute('aria-live', run ? 'off' : 'polite');
      };

      // A manual move starts the countdown over, so the next slide never
      // arrives a moment after the visitor chose one.
      const restart = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        sync();
      };

      const setPaused = (value) => {
        paused = value;
        root.classList.toggle('hero-carousel--paused', paused);
        toggle?.setAttribute('aria-label', paused ? root.dataset.playLabel : root.dataset.pauseLabel);
        sync();
      };

      toggle?.addEventListener('click', () => setPaused(!paused));
      root.addEventListener('pointerenter', () => { hovered = true; sync(); });
      root.addEventListener('pointerleave', () => { hovered = false; sync(); });
      root.addEventListener('focusin', () => { focused = true; sync(); });
      root.addEventListener('focusout', (event) => {
        if (root.contains(event.relatedTarget)) return;
        focused = false;
        sync();
      });
      document.addEventListener('visibilitychange', sync);

      // Theme editor: selecting a slide in the sidebar shows it and holds it.
      root.addEventListener('shopify:block:select', (event) => {
        const i = slides.findIndex((item) => item.contains(event.target) || event.target.contains(item));
        if (i === -1) return;
        editing = true;
        sync();
        goTo(i);
      });
      root.addEventListener('shopify:block:deselect', () => {
        editing = false;
        sync();
      });

      // The later slides load lazily to keep the first one fast. Once the page
      // has loaded, fetch them anyway so they are ready before they slide in.
      const warmUp = () => {
        for (const img of track.querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
      };
      if (document.readyState === 'complete') {
        warmUp();
      } else {
        window.addEventListener('load', warmUp, { once: true });
      }

      controls.hidden = false;
      render();
      setPaused(paused);
    };

    for (const root of document.querySelectorAll('[data-hero-carousel]')) init(root);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-hero-carousel]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WEBHOOK_TIMEOUT_MS = 3000;
    const SOURCE = 'Website newsletter';

    // Resolves once the webhook answers or the timeout passes; never rejects.
    const postToWebhook = (url, email) => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), WEBHOOK_TIMEOUT_MS);

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          tags: ['newsletter'],
          source: SOURCE,
          page_url: window.location.href,
          page_title: document.title,
          submitted_at: new Date().toISOString(),
        }),
        signal: controller.signal,
      })
        .catch(() => {})
        .finally(() => window.clearTimeout(timer));
    };

    // True only when Shopify redirected back with the posted flag. Resolves on
    // the response headers and cancels the body: the redirect target is a full
    // page render that nobody is going to look at.
    const postToShopify = async (form) => {
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        response.body?.cancel();
        return response.ok && new URL(response.url).searchParams.get('customer_posted') === 'true';
      } catch {
        return false;
      }
    };

    const trackSignup = () => {
      const detail = { source: SOURCE, page_url: window.location.href };

      try {
        window.Shopify?.analytics?.publish?.('newsletter_signup', detail);
      } catch {}

      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', { content_name: SOURCE });
        }
      } catch {}
    };

    const showSuccess = (section, form) => {
      const message = document.createElement('p');
      message.className = 'newsletter__message';
      message.setAttribute('role', 'status');
      message.tabIndex = -1;
      message.textContent = section.dataset.successMessage;
      form.replaceChildren(message);
      message.focus({ preventScroll: true });
    };

    for (const section of document.querySelectorAll('[data-newsletter]')) {
      const form = section.querySelector('.newsletter__form');
      const input = form?.querySelector('input[type="email"]');
      if (!input) continue;

      let sending = false;

      form.addEventListener('submit', async (event) => {
        if (sending || !form.checkValidity()) return;
        event.preventDefault();
        sending = true;

        const button = form.querySelector('button[type="submit"]');
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }

        const email = input.value.trim();
        const webhook = section.dataset.ghlWebhook;

        const [saved] = await Promise.all([
          postToShopify(form),
          webhook ? postToWebhook(webhook, email) : null,
        ]);

        if (saved) {
          showSuccess(section, form);
          trackSignup();
          return;
        }

        // Error, challenge or network failure: let Shopify handle it natively.
        // The prototype call skips this listener and any input named "submit".
        HTMLFormElement.prototype.submit.call(form);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
